import React from 'react';
import CallIcon from '@mui/icons-material/Call';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CallReceived from '@mui/icons-material/CallReceived';
import { CallRowViewModel } from '../../ViewModels/IndexContainerViewModels';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { secondsConversion, formatDate } from '../../Utilities/UtilityMethods';

const styles = {
    root: {
        backgroundImage: 'call',
        color: 'black',
    },
    callFailed: {
        minWidth: '32px',
        maxWidth: '32px',
        color: '#ff00007d',
        paddingLeft: '3px',
        paddingRight: '3px',
    },
    callSucceeded: {
        minWidth: '32px',
        maxWidth: '32px',
        color: '#00800094',
        paddingLeft: '3px',
        paddingRight: '3px',
    },
    linkClass: {
        backgroundColor: 'white',
        padding: '2px',
        paddingLeft: '5px',
        paddingRight: '5px',
    },
    tableCell: {
        padding: '4px 12px 4px 12px',
    }
}

interface IMonitoringCallIndexRowProps {
    callId: string
    call: CallRowViewModel
    setId?: (newId: string) => void
}

export default function MonitoringCallIndexRow(props: IMonitoringCallIndexRowProps) {

    let callClass;
    let iconElement;

    switch (props.call.type) {
        case 'Manual Call': {
            callClass = styles.callSucceeded;
            iconElement = <CallIcon className="imageClass" />;
            break;
        }
        case 'O/B Call': {
            callClass = styles.callSucceeded;
            iconElement = <CallMadeIcon className="imageClass" />;
            break;
        }
        case 'O/B Call Failed': {
            callClass = styles.callFailed;
            iconElement = <CallMadeIcon className="imageClass" />;
            break;
        }
        case 'I/B Call': {
            callClass = styles.callSucceeded;
            iconElement = <CallReceived className="imageClass" />;
            break;
        }
        case 'Manual Call Failed': {
            callClass = styles.callFailed;
            iconElement = <CallIcon className="imageClass" />;
            break;
        }
        case 'I/B Call Failed': {
            callClass = styles.callFailed;
            iconElement = <CallReceived className="imageClass" />;
            break;
        }
        default: {
            callClass = styles.root;
            iconElement = <CallIcon className="imageClass" />;
            break;
        }
    }

    const openCallInfo = (e) => {
        if (e.target.tagName !== 'BUTTON' && e.target.tagName !== 'SPAN' && props.setId) {
            const syspk = e.currentTarget.getAttribute('data-key');
            props.setId(syspk);
        }
    }

    return (
        <TableRow
            key={props.call.systemPK}
            data-key={props.call.systemPK}
            onClick={openCallInfo}
            sx={props.call.systemPK === props.callId
                ?
                {
                    backgroundColor: '#2688aa2b',
                    border: 'solid 2px #1d8abf'
                }
                :
                {}}
        >
            <TableCell component="th" scope="row" sx={styles.tableCell}>
                {props.call.agentName}
            </TableCell>
            <TableCell sx={styles.tableCell}>
                {formatDate(props.call.eventTime)}
                <br />
                {new Date(props.call.eventTime).toLocaleTimeString()}
            </TableCell>
            <TableCell sx={styles.tableCell}>
                {secondsConversion(props.call.callLength)}
            </TableCell>
            <TableCell sx={styles.tableCell}>
                {props.call.channel}
                <br />
                {props.call.type}
            </TableCell>
            <TableCell sx={styles.tableCell}>
                <div style={callClass} title={props.call.type}>
                    {iconElement}
                </div>
            </TableCell>
            <TableCell sx={styles.tableCell}>{props.call.result}</TableCell>
            <TableCell sx={styles.tableCell}>
                {props.call.telephone}
            </TableCell>
        </TableRow >
    );
}